// qrPrintFields.js

import { formatFieldValue, getDataSectionName } from 'views/table/utils/tableFieldUtils';
import { resolveSchemaFieldValue } from 'views/utils/fieldValueResolver';

/**
 * buildQrPrintFieldLines
 *
 * Collects schema fields flagged `includeInQrPrint` and formats their
 * values for display under the title on QR stickers / printouts.
 *
 * @param {object|null} node - Node being printed.
 * @param {object|null} typeDef - Node type definition with schema.fields.
 * @returns {{ key: string, label: string, value: string }[]}
 */
export function buildQrPrintFieldLines(node, typeDef) {
  if (!node || !typeDef) return [];

  const fields = Array.isArray(typeDef?.schema?.fields) ? typeDef.schema.fields : [];
  if (!fields.length) return [];

  const typeKey = String(typeDef?.key || node?.type || '').trim();
  const dataSection = getDataSectionName(typeKey);

  return fields
    .filter((field) => field?.includeInQrPrint === true && String(field?.name || '').trim())
    .map((field) => {
      const fieldKey = String(field.name).trim();
      const raw = resolveSchemaFieldValue({
        item: node,
        fieldDef: field,
        typeKey,
        dataSection,
      });
      const value = String(formatFieldValue(raw, field, fieldKey) || '').trim();
      if (!value) return null;

      const label = String(field.label || fieldKey).trim() || fieldKey;
      return {
        key: fieldKey,
        label,
        value,
      };
    })
    .filter(Boolean);
}
